import * as React from 'react';

/* eslint no-return-assign: "error" */
const useMountedRef = () => {
  const mounted = React.useRef(false);
  React.useEffect((): (() => void) => {
    mounted.current = true;
    return () => (mounted.current = false);
  });
  return mounted;
};

export default useMountedRef;
